export const queryKeys = {
  agentBuilderCatalog: (clientId: string, platformTypeId?: number | null) =>
    ['dashboardBuilder', 'agentBuilderCatalog', clientId, platformTypeId ?? null] as const,
  agentBuilderDrilldownHierarchy: (clientId: string, platformTypeId?: number | null) =>
    ['dashboardBuilder', 'agentBuilderDrilldownHierarchy', clientId, platformTypeId ?? null] as const,
  agentBuilderDashboards: (clientId: string, platformTypeId?: number | null) =>
    ['dashboardBuilder', 'agentBuilderDashboards', clientId, platformTypeId ?? null] as const,
  agentBuilderDashboard: (clientId: string, dashboardId?: string | null) =>
    ['dashboardBuilder', 'agentBuilderDashboard', clientId, dashboardId ?? null] as const,
  agentBuilderDashboardVersions: (clientId: string, dashboardId?: string | null) =>
    ['dashboardBuilder', 'agentBuilderDashboardVersions', clientId, dashboardId ?? null] as const,
  agentBuilderDashboardViews: (clientId: string, dashboardRootId?: string | null) =>
    ['dashboardBuilder', 'agentBuilderDashboardViews', clientId, dashboardRootId ?? null] as const,
  agentBuilderDashboardSchedules: (clientId: string, dashboardRootId?: string | null) =>
    ['dashboardBuilder', 'agentBuilderDashboardSchedules', clientId, dashboardRootId ?? null] as const,
  agentBuilderDashboardScheduleRecipients: (clientId: string) =>
    ['dashboardBuilder', 'agentBuilderDashboardScheduleRecipients', clientId] as const,
  agentBuilderClientUserEmailOptions: (clientId: string) =>
    ['dashboardBuilder', 'agentBuilderClientUserEmailOptions', clientId] as const,
  agentBuilderAccessStatus: (clientId: string) =>
    ['dashboardBuilder', 'agentBuilderAccessStatus', clientId] as const,
  agentBuilderSettings: (clientId: string) =>
    ['dashboardBuilder', 'agentBuilderSettings', clientId] as const,
  agentBuilderMemories: (clientId: string, rootDashboardId?: string | null) =>
    ['dashboardBuilder', 'agentBuilderMemories', clientId, rootDashboardId ?? null] as const,
  agentBuilderWidgetInsight: (rootId: string, widgetId: string, signature?: string | null) =>
    ['dashboardBuilder', 'widgetInsight', rootId, widgetId, signature ?? null] as const,
  agentBuilderGroupInsight: (rootId: string, signature?: string | null) =>
    ['dashboardBuilder', 'groupInsight', rootId, signature ?? null] as const,
}
